import { atualizarCarrinho, findCarrinhosByTipo, criarCarrinho, findByIdentificador,
	finalizarMalinhaDoCliente, findVendaPublicDoCarrinho, relacionarVendaAoCarrinho, removerCarrinho, atualizarTotaisDoCarrinho } from '@/api/carrinho'
import { Carrinho, CarrinhoPublico } from '@/models/venda/Carrinho'
import { CarrinhoServiceAdapter } from '@/usecases/venda/adapter/CarrinhoServiceAdapter'
import { AxiosRequestConfig } from 'axios'
import { injectable } from 'inversify-props'


@injectable()
export class CarrinhoService implements CarrinhoServiceAdapter {
	criarCarrinho = async (carrinho: Carrinho)  => await criarCarrinho(carrinho)
		
	atualizarCarrinho = async (carrinho: Carrinho) => await atualizarCarrinho(carrinho)
		
	findCarrinhosByTipo = async (params: any, config?: AxiosRequestConfig) => await findCarrinhosByTipo(params, config)

	findByIdentificador = async (identificador: string) => await findByIdentificador(identificador)

	finalizarMalinhaDoCliente = async (carrinho: CarrinhoPublico) => await finalizarMalinhaDoCliente(carrinho)

	findVendaPublicDoCarrinho = async (carrinhoId: string, vendedorId: string) => await findVendaPublicDoCarrinho(carrinhoId, vendedorId)

	relacionarVendaAoCarrinho = async (vendaId: string, carrinhoId: string) => await relacionarVendaAoCarrinho(vendaId, carrinhoId)

	removerCarrinho = async (idCarrinho: string) => await removerCarrinho(idCarrinho)

	atualizarTotaisDoCarrinho = async (carrinhoId: string, valorTotal: number, quantidadeDePecas: number) =>
		await atualizarTotaisDoCarrinho(carrinhoId, valorTotal, quantidadeDePecas)
}